/**
 * WARNING: Эта страница не попадает в бандл микрофронтенда, используется только для локальной разработки
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './app';

ReactDOM.render(
    <React.StrictMode>
        <App locale="ru" apiPrefix="/api" basename="/" />
    </React.StrictMode>,
    document.getElementById('root')
);
